<template>
  <div>
    <h2 class="pt-20 text-left mh100">Loan History</h2>

    <v-divider></v-divider>
    <br />
    <v-data-table
      :headers="headers"
      :items="loanApplications"
      :loading="loading"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template
        v-if="loanApplications && loanApplications.length > 0"
        v-slot:items="props"
      >
        <td>{{ props.item.id }}</td>
        <!-- <td>{{ props.item.loan_status_title }}</td> -->
        <td>{{ props.item.loan_status.status_for }}</td>
        <td class="textUpper" :title="props.item.product.product_title">
          {{
            props.item.product.product_title
              .split(/\s/)
              .reduce((response, word) => (response += word.slice(0, 1)), "")
          }}
        </td>

        <td style="white-space: nowrap">
          <Date :date="fundingDate(props.item)" />
        </td>

        <td>
          <BDTCurrencyFormat :amount="props.item.amount" />
        </td>
        <td>{{ props.item.duration }}</td>
        <td><BDTCurrencyFormat :amount="props.item.disbursed_amount" /></td>
        <td>
          <BDTCurrencyFormat :amount="props.item.total_monthly_payable" />
        </td>
        <!-- <td>
          <BDTCurrencyFormat :amount="props.item.annual_interest_rate" />
        </td> -->
        <td>
          <BDTCurrencyFormat :amount="props.item.total_full_term_payable" />
        </td>

        <td>
          <v-btn
            small
            @click="goToFundingDetails(props.item.id)"
            color="primary"
            class="mt-2"
            :disabled="props.item.id == $route.params.id"
          >
            Details
          </v-btn>
        </td>
      </template>

      <template v-else v-slot:no-data>
        <div v-if="errorMsg">
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import { userLoanHistory } from "@/utils/variables";
  import BDTCurrencyFormat from "@/components/BDTCurrencyFormat";
  import Date from "@/components/Date";

  export default {
    components: {
      BDTCurrencyFormat,
      Date,
    },
    props: ["userId"],
    data() {
      return {
        loading: true,
        loanApplications: [],
        errorMsg: "",
        headers: [
          { text: "Id", value: "id", title: "Id" },
          {
            text: "Status",
            value: "loan_status",
            title: "Loan Status",
            sortable: false,
          },
          {
            text: "Product",
            value: "product",
            title: "Loan Product Name",
            sortable: false,
          },
          { text: "Date", value: "created_at", date: true, sortable: false },

          { text: "Amount", value: "amount", sortable: false },
          { text: "Duration", value: "duration", sortable: false },
          {
            text: "Disbursed",
            value: "disbursed_amount",
            title: "Disbursed Amount",
            sortable: false,
          },
          { text: "EMI", value: "total_monthly_payable", sortable: false },
          // {
          //   text: "APR",
          //   value: "annual_interest_rate",
          //   title: "Annual Percentage Rate",
          //   sortable: false,
          // },
          {
            text: "Total Payable",
            value: "total_full_term_payable",
            sortable: false,
          },

          // { text: "Actions", value: "name", sortable: false },
        ],
      };
    },
    async mounted() {
      await this.getLoanApplications();
    },
    methods: {
      async getLoanApplications() {
        try {
          const { data } = await HTTP().get(
            `${userLoanHistory}/${this.userId}`
          );
          this.loanApplications = data.data.loan_applications;
          // console.log(this.loanApplications);
        } finally {
          this.loading = false;
        }
      },

      fundingDate(funding) {
        switch (this.status) {
          case 1:
            return funding.created_at;
          case 2:
            return funding.verified_at
              ? funding.verified_at
              : funding.updated_at;
          case 3:
            return funding.rejected_at
              ? funding.rejected_at
              : funding.updated_at;
          case 5:
            return funding.invested_at
              ? funding.invested_at
              : funding.updated_at;
          case 6:
            return funding.agree_accepted_at
              ? funding.agree_accepted_at
              : funding.updated_at;
          case 8:
            return funding.disbursed_at
              ? funding.disbursed_at
              : funding.updated_at;
          case 10:
            return funding.canceled_at
              ? funding.canceled_at
              : funding.updated_at;
          case 11:
            return funding.defaulted_at
              ? funding.defaulted_at
              : funding.updated_at;
          default:
            return funding.updated_at;
        }
      },

      goToFundingDetails(id) {
        const goUrl = `/funding/${id}`;
        const backUrl = this.$router.currentRoute.path;
        const fullUrl = backUrl;
        this.$store.commit("setGoBackRoute", fullUrl);
        this.$router.push(goUrl);
      },
    },
  };
</script>
